import React, { useState, useEffect } from "react";
import { FaChevronRight } from "react-icons/fa";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { gamesService } from "../../services/Games/GamesService";
import increaseicon from "../../assets/images/price-increase.svg";
import { appStore } from "../../stores/appStore";
import Loader from "../ui-components/Loader";
import { useTranslation } from "react-i18next";
import { StyledSuperOdds, StyledSuperOddsContrainer, StyledSuperOddsHeading, StyledSuperOddsTableHeading } from "./SuperOddsStyle";
import { B2BResize } from "../../services/common/globalFunctions";

const SlideOptions = {
  type: "false",
  autoWidth: false,
  pagination: true,
  arrows: false,
  cover: true,
  perPage: 3,
  padding: { right: 20 },
  gap: "0.5rem",
  breakpoints: {
    375: {
      perPage: 1,
      padding: { right: 20 },
    },
    640: {
      perPage: 1,
      padding: { right: 80 },
    },
    768: {
      perPage: 2,
      padding: { right: 90 },
    },
  },
};

const SupperOdds = ({ selectMarketId, selectSuperOddsMarket, viewType }) => {

  // console.log("from super odds");
  const [OddsList, setOddsList] = useState([]);
  const [showLoader, setShowLoader] = useState(false);

  const { t } = useTranslation("General");

  // getting and setting value in appStore
  const {
    liveWeekNumber,
    betSlipSelections,
    setBetSlipSelections,
    currentLeague,
    setBetSlipDetails,
    selectedBetWeek,
    currentSeason,
    generalConfig
  } = appStore((state) => ({
    liveWeekNumber: state.liveWeekNumber,
    betSlipSelections: state.betSlipSelections,
    setBetSlipSelections: state.setBetSlipSelections,
    currentLeague: state.currentLeague,
    setBetSlipDetails: state.setBetSlipDetails,
    selectedBetWeek: state.selectedBetWeek,
    currentSeason: state.currentSeason,
    generalConfig: state.generalConfig
  }));

  const setSuperOdds = (tempOddsList) => {
    tempOddsList.forEach((odds) => {
      odds.selections.forEach((select) => {
        odds.selected = superOddsSelected(odds, select);
      });
    });
    return tempOddsList;
  };

  const superOddsSelected = (odds) => {
    let isSuperOddSelected = false;
    const oddsSelection = betSlipSelections.filter((selection) => {
      return selection._id === odds._id;
    });

    if (oddsSelection.length > 0) {
      isSuperOddSelected = oddsSelection[0]._id === odds._id;
    }
    return isSuperOddSelected;
  };

  // if betslipSelection change then oddsList updating
  useEffect(() => {
    const tempOddsList = setSuperOdds(OddsList);
    setOddsList(tempOddsList);
  }, [betSlipSelections]);

  // super odds selection
  const selectedSuperOdds = (superOddOutCome, selection, index, id) => {
    superOddOutCome.selected = !superOddOutCome.selected;

    let tempOddsList = [...OddsList];
    tempOddsList[index] = { ...superOddOutCome };
    setOddsList(tempOddsList);
    const selections = [];
    if (superOddOutCome.selected) {
      selections.push({
        _id: superOddOutCome._id,
        game_id: "",
        gameId: "",
        gameName: superOddOutCome.outcomeName,
        homeTeam: superOddOutCome.outcomeName,
        awayTeam: superOddOutCome.outcomeName,
        outComeId: superOddOutCome.outComeId,
        outcomeDescription: superOddOutCome.outcomeDescription,
        selectedMarket: {
          marketId: 5,
          marketName: "Super Odds",
          selectedOutCome: {
            outComeId: superOddOutCome.outComeId,
            outcomeName: superOddOutCome.outcomeName,
            outcomeValue: superOddOutCome.outcomeValue,
            odds: superOddOutCome.oddsWithBonus,
          },
        },
      });
    }
    console.log(
      "(liveWeekNumber selectedBetWeek)",
      liveWeekNumber,
      selectedBetWeek,
      (liveWeekNumber + selectedBetWeek).toString()
    );
    setBetSlipDetails({
      betType: "SUPER_ODDS",
      fkLeagueId: currentLeague.leagueId,
      fkSeasonId: currentSeason,
      fkWeekId: (liveWeekNumber + selectedBetWeek).toString(),
    });
    setBetSlipSelections(selections);
  };

  /* fetching leagues list from games backend API  */
  useEffect(() => {
    const getSuperOddsListDetails = async (week) => {
      setShowLoader(true);
      const response = await gamesService.getSuperOddsList(
        currentLeague.leagueId,
        currentSeason,
        liveWeekNumber + week
      );
      let oddsData = response.data;

      if (oddsData.outComesList && oddsData.outComesList.length > 0) {
        const updatedSuperOdds = setSuperOdds(oddsData.outComesList);
        setOddsList(updatedSuperOdds);
      }
      setTimeout(() => {
        B2BResize("Matches Pages");
      }, 500);

      setShowLoader(false);
    };
    if (
      currentLeague &&
      currentLeague.leagueId &&
      currentSeason &&
      liveWeekNumber >= 0
    ) {
      getSuperOddsListDetails(selectedBetWeek);
    }
  }, [currentLeague, liveWeekNumber, selectedBetWeek]);

  return showLoader ? (
    <Loader />
  ) : (
    <React.Fragment>
      <div className={`w-100`}>
        {selectMarketId === 5 && viewType === "TABLE" ? (
          <div className="live-table w-100">
            <StyledSuperOddsTableHeading className="row m-0 py-2 bg-primary text-white d-flex justify-content-around justify-items-center align-items-center">
              <div className="text-start">
                <span>
                  {" "}
                  {t("Gameweek")} {liveWeekNumber + selectedBetWeek}{" "}
                  {t("Super Odds")}
                </span>
              </div>
            </StyledSuperOddsTableHeading>
            <div className="text-dark px-1 fw-bold superOdds-table-font">
              {OddsList.map((superOdds, index) => (
                <div
                  className="d-flex justify-content-between align-items-center border-bottom p-2"
                  key={index}
                >
                  <div className="w-50">
                    {t(`${superOdds.outcomeName}`)} - {" "}
                    {t(`${superOdds.outcomeDescription}`)}
                  </div>

                  <div className="d-flex justify-content-end align-items-center bonus-superOdds">
                    <div className="w-100 text-end me-2">
                      <s className="fw-normal">
                        {t("was")}&nbsp;{superOdds.odds.toFixed(2)}
                      </s>
                    </div>
                    <div className="w-100">
                      <StyledSuperOdds selected={superOdds.selected}
                        className={`btn btn-lg btn-outline-secondary market-outcome w-100 rounded superOdds-table-outcome border 
                        ${superOdds.selected
                            ? "active text-white border-secondary"
                            : "odds-btn text-black bg-light border border-light"
                          }`}
                        onClick={() =>
                          selectedSuperOdds(
                            superOdds,
                            superOdds.outcomeName,
                            index,
                            superOdds._id
                          )
                        }
                      >
                        {superOdds.oddsWithBonus.toFixed(2)}
                      </StyledSuperOdds>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <StyledSuperOddsContrainer className={`pt-2 px-3 pb-3 ${generalConfig.hideSuperOddsSection ? 'd-block' : 'd-none'}`}>
            <Splide aria-label="My Favorite Images" options={SlideOptions}>
              {OddsList.map((superOdds, index) => {
                return (
                  <SplideSlide key={index}>
                    <div className="card bg-white text-black rounded-3">
                      <div
                        className="card-body p-0 shadow"
                      >
                        <StyledSuperOddsHeading
                          style={{ padding: "3px 10px" }}
                          className="card-title rounded-pill rounded-start mt-2 mb-1 bg-primary text-white d-inline-block"
                        >
                          <img
                            style={{ marginRight: "3px", marginBottom: "3px" }}
                            src={increaseicon}
                            className=""
                            alt="logo"
                            height={"12px"}
                          />{" "}
                          {t("Super Odds")} &nbsp;
                        </StyledSuperOddsHeading>
                        <div className="card-text d-flex justify-content-between justify-items-center p-2 pb-0">
                          <div className="odds-desc overflow-hidden me-2">
                            {t(`${superOdds.outcomeName}`)} - {" "}
                            {t(`${superOdds.outcomeDescription}`)}
                          </div>
                          <div>
                            <StyledSuperOdds selected={superOdds.selected}
                              onClick={() =>
                                selectedSuperOdds(
                                  superOdds,
                                  superOdds.outcomeName,
                                  index,
                                  superOdds._id
                                )
                              }
                              className={`mb-1 rounded superoddsbtn ${superOdds.selected
                                ? "btn bg-secondary text-white border-secondary"
                                : "odds-btn text-black bg-light border border-light"
                                }`}
                            >
                              <b>{superOdds.oddsWithBonus.toFixed(2)}</b>
                            </StyledSuperOdds>
                            <p className="text-end text-center mb-0 ">
                              <s>
                                {t("was")}&nbsp;{superOdds.odds.toFixed(2)}
                              </s>
                            </p>
                          </div>
                        </div>
                        <div
                          style={{ padding: "6px 10px" }}
                          onClick={selectSuperOddsMarket}
                          className="card-footer border border-0 d-flex justify-content-between align-items-center cursor"
                        >
                          <div>
                            {t("All Gameweek")}{" "}
                            {liveWeekNumber + selectedBetWeek}{" "}
                            {t("Super Odds")}
                          </div>
                          <div>
                            {/* <BsChevronRight />
                            <HiChevronRight /> */}
                            <FaChevronRight />
                          </div>
                        </div>
                      </div>
                    </div>
                  </SplideSlide>
                );
              })}
            </Splide>
          </StyledSuperOddsContrainer>
        )}
      </div>
    </React.Fragment>
  );
};
export default SupperOdds;
